export default {
	paragraphs: [
		"Once the funds leave FacilitaPay’s environment to complete a transaction—such as a payout or a requested settlement—this webhook will be triggered to notify you that the wire has been completed. In short, it means the funds have already been sent either to your customer’s bank account or to your external international bank account.",
		"Note that a single wire transfer can be associated with multiple transactions if they share the same subject and destination account. For this reason, you will receive a list of transaction IDs in the transaction_ids field.",
		"Example:",
		"You need to send money to your customer and create two transactions using the same destination bank account. Instead of sending the funds separately, we will group them and send a single wire with the total amount of both transactions combined."
	],
	path: "notification_wire_created",
	request: {
		method: "POST",
		payloads: [
			{
				title: "Notification",
				content: {
					"notification": {
						"type": "wire_created",
						"wire_id": "some_uuid",
						"transaction_ids": [
							"transaction-id-a",
							"transaction-id-b"
						],
						"secret": "the value you received"
					}
				}
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationWireCreated.js